import React, { useState } from 'react';
import { formatRoute } from 'react-router-named-routes';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Grid } from '@mui/material';
import { END_USER_FIND_ALTERNATIVES_GRC_RECIPE_ROUTE } from '../../services/routes';
import { linkWithQueryParams } from '../../services/urls';
import TopNavBar from '../user/top_nav_bar';
import MealBasketWidget from '../../features/end_user_shopping/components/meal_basket_widget';
import PopupTitle from '../common/popup_title';
import EndUserFindAlternativesGRCRecipeItem from './end_user_find_alternatives_grc_recipe_item';
import NarrowEndUserMoreButton from '../meal/narrow_end_user_more_button';
import {
  useGetGRCRecipeCategoriesQuery,
  useGetGRCResultQuery,
} from '../../app/smorgAppSyncGraphQLApi';
import { useGetEndUserSpaceQuery } from '../../app/smorgAppSyncGraphQLApiCustomHooks';

const EndUserFindAlternativesGRCRecipeCategoryView = () => {
  const navigate = useNavigate();

  const [offset, setOffset] = useState(0);

  const { calendarDay, categoryID } = useParams();

  const [searchParams] = useSearchParams();

  const mealIDToReplace = searchParams.get('mealId');
  const mealType = searchParams.get('mealType');

  const { data: currentSpace } = useGetEndUserSpaceQuery();

  const { data: grcRecipeCategories } = useGetGRCRecipeCategoriesQuery(
    currentSpace?.id,
    {
      skip: !currentSpace?.id,
    },
  );

  const { data: grcResult, isLoading: isGrcResultLoading } =
    useGetGRCResultQuery(
      { spaceID: currentSpace?.id, grcRecipeCategoryID: categoryID, offset },
      {
        skip: !currentSpace?.id || !categoryID,
      },
    );

  const grcRecipeCategory = grcRecipeCategories.find(
    (c) => c.id === categoryID,
  );

  const title = grcRecipeCategory?.title;

  const grcRecipeIDs = (grcResult?.data || []).map((item) => item.grcRecipeID);

  const moreAvailable = grcResult?.moreAvailable;

  const onLoadMore = setOffset(grcResult?.nextOffset);

  const onClickResultDetail = (grcRecipeID) => {
    navigate(
      linkWithQueryParams(
        formatRoute(END_USER_FIND_ALTERNATIVES_GRC_RECIPE_ROUTE, {
          calendarDay,
          grcRecipeId: grcRecipeID,
        }),
        { mealType, mealId: mealIDToReplace },
      ),
    );
  };

  return (
    <div className="recipes-search">
      <TopNavBar />
      <MealBasketWidget />
      <div>
        <div
          className="topNavBarMobile topNavBarMobileLight"
          style={{
            color: 'var(--app-primary-font-color)',
            height: '70px',
            flexDirection: 'column',
          }}>
          <PopupTitle
            titleText={title}
            backButtonEnabled
            onClickBack={() => navigate(-1)}
          />
        </div>
        <Grid container>
          {grcRecipeIDs.map((grcRecipeID) => (
            <Grid
              item
              xs={6}
              sm={4}
              md={3}
              lg={2}
              key={grcRecipeID}
              style={{ flexShrink: 0 }}>
              <EndUserFindAlternativesGRCRecipeItem
                calendarDay={calendarDay}
                grcRecipeID={grcRecipeID}
                mealType={mealType}
                mealIDToReplace={mealIDToReplace}
                onClick={onClickResultDetail}
              />
            </Grid>
          ))}
          {isGrcResultLoading && (
            <Grid
              item
              xs={6}
              sm={4}
              md={3}
              lg={2}
              style={{ color: 'var(--app-primary-font-color)' }}>
              <NarrowEndUserMoreButton isLoading onClick={() => {}} />
            </Grid>
          )}
          {!isGrcResultLoading && moreAvailable && (
            <Grid item xs={6} sm={4} md={3} lg={2}>
              <NarrowEndUserMoreButton onClick={onLoadMore} />
            </Grid>
          )}
        </Grid>
      </div>
    </div>
  );
};

export default EndUserFindAlternativesGRCRecipeCategoryView;
